<template>
    <div class="col-12 col-md-6 col-lg-4 p-3 c-gray">
        <vue-card bodyClass>
            <header slot="header" class="header">{{item.fbc_alias}}</header>
            <ul class="list-group list-group-flush">
                <li class="list-group-item">
                    <div class="row">
                        <div class="col">
                            <p>Current reading</p>
                            <div class="temp">
                                {{ formatTemp(item.s_reading)}}
                                <span
                                    class="unit stong"
                                >{{ item.s_unit}}</span>
                            </div>
                        </div>
                        <div class="col">
                            <p>Setpoint</p>
                            <div class="temp">
                                {{ formatTemp(item.fbc_setpoint)}}
                                <span
                                    class="unit stong"
                                >{{ item.s_unit}}</span>
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="row">
                                <a class="btn arrow" @click="setpointUp()" href="#">
                                    <i class="fas fa-caret-square-up c-gray"></i>
                                </a>
                            </div>
                            <div class="row">
                                <a class="btn arrow" @click="setpointDown()" href="#">
                                    <i class="fas fa-caret-square-down c-gray"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="list-group-item">
                    <p>Current states</p>
                    <div>
                        <i
                            class="fas fa-burn"
                            v-bind:class="[item.fbc_status ? 'c-red' : 'c-gray']"
                        ></i>
                        {{formatText(item.fbc_name) }}
                    </div>
                    <div>
                        <i class="fas fa-burn" v-bind:class="[item.a_status ? 'c-red' : 'c-gray']"></i>
                        {{formatText(item.a_name) }}
                    </div>
                </li>
            </ul>

            <footer slot="footer" class="small">
                {{$t('lastupdate')}}: {{ timestampLong }}
                <a
                    class="float-right"
                    data-toggle="collapse"
                    :href="'#'+collapseName"
                    role="button"
                    aria-expanded="false"
                    :aria-controls="collapseName"
                >Show details</a>
                <div class="collapse" :id="collapseName">
                    <hr />
                    <pre class="small">
                        <p class v-for="(i, name) in item" :key="name">{{ name }}: {{i}}</p>
                    </pre>
                </div>
            </footer>
        </vue-card>
    </div>
</template>


<script>
import moment from "moment";
//import axios from "axios";
//import LineChart from './baase-components/VChart.vue'

export default {
    components: {
        //lineChart: LineChart ,
    },
    props: ["item"],
    //extends: Line,
    data() {
        return {
            quantity: 0,
            collapseName: "collapsePre" + this.item.fbc_name,
            // labels: [],
            // values: [],
            // chartdata: [],
            // options: { responsive: true },
            // loaded: false,
            // datacollection: { labels:[], datasets: {data: []}},
        };
    },
    async mounted() {},
    computed: {
        timestampLong() {
            return moment(this.item.timestamp).format("dddd DD.MM.YYYY HH:mm");
        },
        timestamp() {
            return moment(this.item.timestamp).format("DD.MM.YYYY HH:mm");
        },
    },
    methods: {
        setpointUp() {
            let setpoint = parseFloat(this.item.fbc_setpoint) + 0.5;

            let data = {
                name: this.item.fbc_name,
                setpoint: setpoint,
            };
            this.$emit("setSetpoint", data);
        },
        setpointDown() {
            let setpoint = parseFloat(this.item.fbc_setpoint) - 0.5;
            let data = {
                name: this.item.fbc_name,
                setpoint: setpoint,
            };
            this.$emit("setSetpoint", data);
        },

        formatTemp(value) {
            let val = (value / 1).toFixed(1).replace(".", ",").trim();
            return val;
            //return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },

        formatTimestamp(value) {
            return moment(value).format("DD.MM.YYYY HH:mm");
        },
        formatTimestampWithSeconds(value) {
            return moment(value).format("DD.MM.YYYY HH:mm:ss");
        },
        formatText(value) {
            if (value == null) return "";
            return value.replaceAll("_", " ");
        },
    },
};
</script>

<style scoped>
.danger {
    border: 1px solid red;
}

.c-gray {
    color: #888;
}
.c-red {
    color: red;
}

.card-body {
    display: flex;
    flex-direction: row;
}

.header {
    font-weight: 600;
    font-size: 22px;
}

.right {
    text-align: right;
}

.temp {
    font-size: 60px;
    line-height: 60px;
    display: inline-flex;
}

.unit {
    font-weight: 600;
    font-size: 22px;
    line-height: 30px;
    vertical-align: top;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 0.2em;
}

.setpoint {
    font-size: 18px;
    line-height: 30px;
    vertical-align: bottom;
    display: flex;
    flex-direction: column;
    margin-left: -1em;
}

.arrow {
    font-size: 45px;
    line-height: 40px;
    display: inline-flex;
}
</style>